<template>
  <div :class="wrapperClasses">
    <div v-if="message" :class="classObject">
      <div class="sf-level">
        <div class="fa fa-exclamation-triangle" />
        <div>{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'warning',
      validator: function (value) {
        return ['success', 'notice', 'alert', 'error'].indexOf(value) !== -1
      },
    },
    wrapperClasses: {
      type: String,
      default: '',
    },
  },

  computed: {
    classObject: function () {
      return {
        'sf-layer-rounded': true,
        'sf-pad-h-2': true,
        'sf-pad-v-1': true,
        [`sf-bg-${this.flashClassForType}-subtle`]: true,
        [`sf-c-${this.flashClassForType}-dark`]: true,
      }
    },
    flashClassForType() {
      return {
        alert: 'warning',
        error: 'danger',
        notice: 'info',
        success: 'success',
      }[this.type]
    },
  },
}
</script>
